export enum NoteType {
    TaxNote = 1,
    DebitNote = 2,
    Invoice = 3
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/NoteType.ts